<template>
    <flex-container>
        <!-- Bedrijfsgegevens -->
        <card-normal>
            <form-validation ref="companyBindings">
                <flex-container>
                    <flex-container :size="5" class="seperator">
                        <flex-container>
                            <flex-container :gap="Size.sm" justify-content="space-between">
                                <text-heading>Bedrijfsgegevens</text-heading>
                                <chip-informative :color="companyFormIsValid ? 'green-500' : 'red-500'">
                                    Verplicht
                                </chip-informative>
                            </flex-container>
                            <flex-container>
                                <input-group
                                    v-model="formData.company.name"
                                    :schema="string().required()"
                                >
                                    <template #input>
                                        <flex-container :gap="Size.xs">
                                            <text-decorator :size="FontSize.xs">
                                                Bedrijfsnaam (verplicht)
                                            </text-decorator>
                                            <text-input />
                                        </flex-container>
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                    <flex-container :size="5">
                        <flex-container>
                            <flex-container justify-content="flex-end">
                                <chip-informative>Optioneel</chip-informative>
                            </flex-container>
                            <flex-container>
                                <input-group
                                    v-model="formData.company.note"
                                    :schema="string().nullable()"
                                >
                                    <template #input>
                                        <flex-container :gap="Size.xs">
                                            <text-decorator :size="FontSize.xs">
                                                Notitie
                                            </text-decorator>
                                            <rich-text-area-input :mentionables="[]" />
                                        </flex-container>
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                </flex-container>
            </form-validation>
        </card-normal>

        <!-- Beheerder -->
        <card-normal>
            <form-validation ref="userBindings">
                <flex-container>
                    <flex-container :size="5" class="seperator">
                        <flex-container :gap="Size.sm" justify-content="space-between">
                            <text-heading>Beheerder</text-heading>
                            <chip-informative :color="userFormIsValid ? 'green-500' : 'red-500'">
                                Verplicht
                            </chip-informative>
                        </flex-container>
                        <flex-container>
                            <input-group
                                v-model="formData.user.email"
                                :schema="string().email().required()"
                            >
                                <template #input>
                                    <flex-container :gap="Size.xs">
                                        <text-decorator :size="FontSize.xs">
                                            E-mail adres
                                        </text-decorator>
                                        <text-input />
                                    </flex-container>
                                </template>
                            </input-group>
                        </flex-container>
                    </flex-container>
                    <flex-container :size="5">
                        <flex-container>
                            <flex-container justify-content="flex-end">
                                <chip-informative>Optioneel</chip-informative>
                            </flex-container>
                            <flex-container>
                                <flex-container :size="4">
                                    <input-group
                                        v-model="formData.user.firstname"
                                        :schems="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Voornaam
                                                </text-decorator>
                                                <text-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container :size="2">
                                    <input-group
                                        v-model="formData.user.middlename"
                                        :schems="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Tussenvoegsel
                                                </text-decorator>
                                                <text-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container :size="4">
                                    <input-group
                                        v-model="formData.user.lastname"
                                        :schems="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Achternaam
                                                </text-decorator>
                                                <text-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.user.gender"
                                        :schema="Gender.validationSchema.required()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Geslacht
                                                </text-decorator>
                                                <select-input
                                                    :items="Gender.options"
                                                />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                </flex-container>
            </form-validation>
        </card-normal>

        <!-- Merk -->
        <card-normal>
            <form-validation ref="brandBindings">
                <flex-container>
                    <flex-container :size="5" class="seperator">
                        <flex-container>
                            <flex-container :gap="Size.sm" justify-content="space-between">
                                <text-heading>Merk</text-heading>
                                <chip-informative :color="brandFormIsValid ? 'green-500' : 'red-500'">
                                    Verplicht
                                </chip-informative>
                            </flex-container>
                            <flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.brand.name"
                                        :schema="string().required()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Merk naam
                                                </text-decorator>
                                                <text-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.brand.websiteUrl"
                                        :schema="string().url().required()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Website URL
                                                </text-decorator>
                                                <text-input placeholder="https://www." />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                    <flex-container :size="5">
                        <flex-container>
                            <flex-container justify-content="flex-end">
                                <chip-informative>Optioneel</chip-informative>
                            </flex-container>
                            <flex-container>
                                <flex-container :size="5">
                                    <input-group
                                        v-model="formData.brand.primaryColor"
                                        :schema="string().required()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Primaire kleur
                                                </text-decorator>
                                                <color-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container :size="5">
                                    <input-group
                                        v-model="formData.brand.secondaryColor"
                                        :schema="string().required()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Secundaire kleur
                                                </text-decorator>
                                                <color-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.brand.googleTagId"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Google Tag ID
                                                </text-decorator>
                                                <text-input placeholder="GTM-XXXX" />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                </flex-container>
            </form-validation>
        </card-normal>

        <!-- Vestiging -->
        <card-normal>
            <form-validation ref="teamBindings">
                <flex-container>
                    <flex-container :size="5" class="seperator">
                        <flex-container>
                            <flex-container :gap="Size.sm" justify-content="space-between">
                                <text-heading>Vestiging</text-heading>
                                <chip-informative :color="teamFormIsValid ? 'green-500' : 'red-500'">
                                    Verplicht
                                </chip-informative>
                            </flex-container>
                            <flex-container>
                                <input-group
                                    v-model="formData.team.name"
                                    :schema="string().required()"
                                >
                                    <template #input>
                                        <flex-container :gap="Size.xs">
                                            <text-decorator :size="FontSize.xs">
                                                Vestiging naam
                                            </text-decorator>
                                            <text-input />
                                        </flex-container>
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                    <flex-container :size="5">
                        <flex-container>
                            <flex-container justify-content="flex-end">
                                <chip-informative>Optioneel</chip-informative>
                            </flex-container>
                            <flex-container>
                                <flex-container :size="6">
                                    <input-group
                                        v-model="formData.team.zipcode"
                                        :schema="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Postcode
                                                </text-decorator>
                                                <text-input @focusout="searchForZipCode" />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container :size="4">
                                    <input-group
                                        v-model="formData.team.streetnumber"
                                        :schema="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Huisnummer
                                                </text-decorator>
                                                <text-input @focusout="searchForZipCode" />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container :size="5">
                                    <input-group
                                        v-model="formData.team.streetname"
                                        :schema="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Straatnaam
                                                </text-decorator>
                                                <text-input :disabled="disableAddress" />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container :size="5">
                                    <input-group
                                        v-model="formData.team.city"
                                        :schema="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Plaatsnaam
                                                </text-decorator>
                                                <text-input :disabled="disableAddress" />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.team.phoneNumber"
                                        :schema="string().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Telefoonnummer
                                                </text-decorator>
                                                <text-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.team.websiteUrl"
                                        :schema="string().url().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Website URL
                                                </text-decorator>
                                                <text-input placeholder="https://www." />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.team.email"
                                        :schema="string().email().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Algemeen e-mail adres
                                                </text-decorator>
                                                <text-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                </flex-container>
            </form-validation>
        </card-normal>

        <!-- Abonnement -->
        <card-normal>
            <form-validation ref="subscriptionBindings">
                <flex-container>
                    <flex-container :size="5" class="seperator">
                        <flex-container>
                            <flex-container :gap="Size.sm" justify-content="space-between">
                                <text-heading>Abonnement</text-heading>
                                <chip-informative :color="subscriptionFormIsValid ? 'green-500' : 'red-500'">
                                    Verplicht
                                </chip-informative>
                            </flex-container>
                            <flex-container>
                                <input-group
                                    v-model="formData.subscription.plan"
                                    :schema="object().required()"
                                >
                                    <template #input>
                                        <flex-container :gap="Size.xs">
                                            <text-decorator :size="FontSize.xs">
                                                Abonnement
                                            </text-decorator>
                                            <select-input
                                                :items="plansCollection.data.value"
                                                value-key-name="id"
                                                label-key-name="name"
                                            />
                                        </flex-container>
                                    </template>
                                </input-group>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                    <flex-container :size="5">
                        <flex-container>
                            <flex-container justify-content="flex-end">
                                <chip-informative>Optioneel</chip-informative>
                            </flex-container>
                            <flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.subscription.discountAmount"
                                        :schema="number().required().min(0).integer().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Korting in euros
                                                </text-decorator>
                                                <text-input />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                                <flex-container>
                                    <input-group
                                        v-model="formData.subscription.discountEndDate"
                                        :schema="date().nullable()"
                                    >
                                        <template #input>
                                            <flex-container :gap="Size.xs">
                                                <text-decorator :size="FontSize.xs">
                                                    Korting loopt tot datum
                                                </text-decorator>
                                                <date-input
                                                    horizontal-position="center"
                                                    vertical-position="center"
                                                />
                                            </flex-container>
                                        </template>
                                    </input-group>
                                </flex-container>
                            </flex-container>
                        </flex-container>
                    </flex-container>
                </flex-container>
            </form-validation>
        </card-normal>

        <flex-container justify-content="right">
            <button-block :disabled="!everythingValid" @loading="createLicense">
                Aanmaken
            </button-block>
        </flex-container>
    </flex-container>
</template>

<script setup lang="ts">
    import {
        Company as LegacyCompany,
        User as LegacyUser,
        CompanyLicenseType,
        CompanyType as LegacyCompanyType,
        LicenseAPI as LegacyLicenseAPI,
    } from '@keyvue/one-api-client-legacy';

    import {
        ButtonState,
        FontSize,
        Size,
        type ButtonStateChangedEvent,
        type FormValidationBindings,
        ColorInput,
        FlexContainer,
        InputGroup,
        SelectInput,
        TextDecorator,
    } from '@keyvue/one-ui';

    import {
        Company,
        Gender,
        User,
        ChangeUserKeyflowRoleCommand,
        KeyflowRole,
        CreateTeamCommand,
        TeamId,
        TeamType,
        BrandId,
        CreateBrandCommand,
        PlanId,
        Plan,
        CreateSubscriptionCommand,
        SubscriptionId,
        ResourceId,
    } from '@keyvue/one-api-client';

    import { computed, ref, watch } from 'vue';
    import { v4 as uuid } from 'uuid';
    import { date, number, object, string } from 'yup';
    import { useRouter } from 'vue-router';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import useNotify from '@/services/keyvue-ui/composables/useNotify';
    import PostcodeAPI from '@/services/postcode-api/postcodeApi';

    const { notifySaving, notifySaved, notifyError } = useNotify();
    const { client, getResourceCollection } = useClient();
    const router = useRouter();

    const legacyCompanyId = ref(uuid());
    const legacyUserId = ref(uuid());
    const brandId = ref(uuid());
    const teamId = ref(uuid());
    const subscriptionId = ref(uuid());

    const formData = ref<{
        company: {
            name: string,
            note: string | null,
        },
        user: {
            email: string,
            gender: Gender,
            firstname: string | null,
            middlename: string | null,
            lastname: string | null,
        },
        brand: {
            name: string,
            primaryColor: string,
            secondaryColor: string,
            googleTagId: string | null,
            websiteUrl: string,
        },
        team: {
            name: string,
            zipcode: string | null,
            streetnumber: string | null,
            streetname: string | null,
            city: string | null,
            phoneNumber: string | null,
            websiteUrl: string | null,
            email: string | null,
        },
        subscription: {
            plan: Plan | null,
            discountAmount?: number,
            discountEndDate: Date | null,
        },
    }>({
        company: {
            name: '',
            note: null,
        },
        user: {
            email: '',
            gender: Gender.MALE,
            firstname: '',
            middlename: '',
            lastname: '',
        },
        brand: {
            name: '',
            primaryColor: '#F69800',
            secondaryColor: '#1B3D6D',
            googleTagId: null,
            websiteUrl: '',
        },
        team: {
            name: '',
            zipcode: null,
            streetnumber: null,
            streetname: null,
            city: null,
            phoneNumber: null,
            websiteUrl: null,
            email: null,
        },
        subscription: {
            plan: null,
            discountAmount: 0,
            discountEndDate: null,
        },
    });

    const disableAddress = ref(false);
    const disableRefresh = ref(false);

    async function searchForZipCode() {
        if (!formData.value.team.zipcode || !formData.value.team.streetnumber) {
            return;
        }

        disableRefresh.value = true;

        try {
            const response = await PostcodeAPI.lookup(formData.value.team.zipcode, formData.value.team.streetnumber);
            formData.value.team.city = response.city.label ?? '';
            formData.value.team.streetname = response.street;
            disableAddress.value = true;
        } catch (e) {
            disableAddress.value = false;
            disableRefresh.value = false;
        }

        disableRefresh.value = false;
    }

    async function createLicenseInKeyvue() {
        const closeNotification = notifySaving('Bezig met aanmaken basisdata', 0);
        await LegacyLicenseAPI.create(
            LegacyCompany.fromData({
                id: legacyCompanyId.value,
                name: formData.value.company.name,
                type: LegacyCompanyType.REALTOR,
                note: formData.value.company.note,
                license: true,
                betaOptInAvailable: true,
                licenseType: CompanyLicenseType.WINCK,
                modules: [],
                amountOfUsers: 0,
                amountOfBranches: 0,
            } as Partial<LegacyCompany>),
            LegacyUser.fromData({
                id: legacyUserId.value,
                firstname: formData.value.user.firstname,
                middlename: formData.value.user.middlename,
                lastname: formData.value.user.lastname,
                gender: formData.value.user.gender.value,
                email: formData.value.user.email,
            } as Partial<LegacyUser>),
        );

        closeNotification();
    }

    async function waitForSync() {
        const closeNotification = notifySaving('Bezig met synchroniseren van data', 0);
        await new Promise((resolve) => { setTimeout(resolve, 5000); });
        closeNotification();
    }

    async function createBrand(company: Company) {
        await client.dispatch(new CreateBrandCommand(
            company.id.value,
            brandId.value,
            formData.value.brand.name,
            null, // logoId,
            formData.value.brand.primaryColor,
            formData.value.brand.secondaryColor,
            null, // textColor,
            null, // linkColor,
            null, // buttonColor,
            null, // buttonTextColor,
            'Roboto', // headingFontName,
            'Roboto', // fontName,
            formData.value.brand.googleTagId,
            formData.value.brand.websiteUrl,
            {}, // additionalUrls,
            true,
            null,
            null,
        ));
    }

    async function createTeam(company: Company) {
        await client.dispatch(new CreateTeamCommand(
            company.id,
            new TeamId(teamId.value),
            formData.value.team.name,
            TeamType.WINCK,
            formData.value.team.name,
            formData.value.team.streetname,
            formData.value.team.streetnumber,
            null, // addressNumberSuffix,
            formData.value.team.zipcode,
            formData.value.team.city,
            null, // addressRegion,
            null, // addressCountry,
            formData.value.team.phoneNumber,
            formData.value.team.email,
            formData.value.team.websiteUrl,
            new BrandId(brandId.value),
            true,
        ));
    }

    async function createSubscription(company: Company) {
        if (!formData.value.subscription.plan) {
            throw new Error('Geen abonnement geselecteerd');
        }

        // @todo: moet nullable zijn?
        if (!formData.value.subscription.discountEndDate) {
            formData.value.subscription.discountEndDate = new Date();
        }

        await client.dispatch(new CreateSubscriptionCommand(
            company.id,
            new SubscriptionId(subscriptionId.value),
            formData.value.subscription.plan.id as ResourceId<PlanId>,
            formData.value.subscription.discountAmount,
            formData.value.subscription.discountEndDate,
        ));
    }

    async function setUserRole(user: User) {
        await client.dispatch(new ChangeUserKeyflowRoleCommand(
            user.id,
            KeyflowRole.COMPANY_MANAGER,
        ));
    }

    async function updateInWinck() {
        const closeNotification = notifySaving('Bezig met ophalen en verwerken gegevens', 0);
        const company = await client.get(Company, legacyCompanyId.value);
        const user = await client.get(User, legacyUserId.value);

        if (!company || !user) {
            throw new Error('Bedrijf of gebruiker niet gevonden');
        }

        await createBrand(company);
        await createTeam(company);
        await createSubscription(company);
        await setUserRole(user);
        closeNotification();
    }

    async function createLicense(event: ButtonStateChangedEvent) {
        try {
            await createLicenseInKeyvue();
            await waitForSync();
            await updateInWinck();

            notifySaved('Gelukt!', 'De licentie is aangemaakt');
            event.button.setState(ButtonState.completed);
            await router.push({ name: 'license-overview' });
        } catch (error) {
            notifyError(error);
            event.button.setState(ButtonState.content);
        }
    }

    const plansCollection = await getResourceCollection(Plan);

    // Automatically copy company name into brand and team name
    watch(() => formData.value.company.name, (value, oldValue) => {
        if (!oldValue || oldValue === formData.value.brand.name) {
            formData.value.brand.name = value;
        }

        if (!oldValue || oldValue === formData.value.team.name) {
            formData.value.team.name = value;
        }
    });

    // Automatically copy brand website into team website
    watch(() => formData.value.brand.websiteUrl, (value, oldValue) => {
        if (!oldValue || oldValue === formData.value.team.websiteUrl) {
            formData.value.team.websiteUrl = value;
        }
    });

    const companyBindings = ref<{ formValidationBindings: FormValidationBindings }>();
    const userBindings = ref<{ formValidationBindings: FormValidationBindings }>();
    const brandBindings = ref<{ formValidationBindings: FormValidationBindings }>();
    const teamBindings = ref<{ formValidationBindings: FormValidationBindings }>();
    const subscriptionBindings = ref<{ formValidationBindings: FormValidationBindings }>();

    const companyFormIsValid = computed(() => companyBindings?.value?.formValidationBindings.isValid.value);
    const userFormIsValid = computed(() => userBindings?.value?.formValidationBindings.isValid.value);
    const brandFormIsValid = computed(() => brandBindings?.value?.formValidationBindings.isValid.value);
    const teamFormIsValid = computed(() => teamBindings?.value?.formValidationBindings.isValid.value);
    const subscriptionFormIsValid = computed(() => subscriptionBindings?.value?.formValidationBindings.isValid.value);

    const everythingValid = computed(() => [
        companyFormIsValid,
        userFormIsValid,
        brandFormIsValid,
        teamFormIsValid,
        subscriptionFormIsValid,
    ].every((isValid) => isValid.value));
</script>

<style scoped lang="scss">
    .seperator {
        border-right: dashed size(xxs) color(gray-300);
        padding-right: size(md)
    }
</style>
